import { render, staticRenderFns } from "./auth-ok.vue?vue&type=template&id=3b647822&scoped=true&"
import script from "./auth-ok.vue?vue&type=script&lang=js&"
export * from "./auth-ok.vue?vue&type=script&lang=js&"
import style0 from "./auth-ok.vue?vue&type=style&index=0&id=3b647822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b647822",
  null
  
)

export default component.exports